import { render } from "./TranscriptBlock.vue?vue&type=template&id=344670d2&scoped=true&ts=true"
import script from "./TranscriptBlock.vue?vue&type=script&lang=ts"
export * from "./TranscriptBlock.vue?vue&type=script&lang=ts"

import "./TranscriptBlock.vue?vue&type=style&index=0&id=344670d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344670d2"]])

export default __exports__